import { render, staticRenderFns } from "./Research.vue?vue&type=template&id=3dca187b&scoped=true&"
import script from "./Research.vue?vue&type=script&lang=ts&"
export * from "./Research.vue?vue&type=script&lang=ts&"
import style0 from "./Research.vue?vue&type=style&index=0&id=3dca187b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dca187b",
  null
  
)

export default component.exports